import { type LoggerContextProps } from "../context/LoggerContext";
import { getIsoTimeStringWithMs } from "../utils/getIsoTimeStringWithMs";
import { type LoggerProps } from "./type";

/**
 * Events mapping: https://microsoft.sharepoint-df.com/:w:/t/ProjectLibbie/EfRBFyTCLPpFmVnxQDOUNCsBrdhYlbhGOpKIfRfbM379VA?e=VMcroX
 */
export const promptCardLogger = ({
  logger,
  logicalId,
  scenarioName,
  metaData,
}: LoggerContextProps) => {
  const sendPromptCardClickEvent = ({ prompt }: LoggerProps) => {
    logger.log3sEvent?.({
      localTime: getIsoTimeStringWithMs(new Date()),
      eventType: "SearchEntityClicked",
      logicalId,
      scenario: scenarioName,
      id: prompt.ReferenceId ?? "null",
      metaData: JSON.stringify({
        referenceId: `${prompt.ReferenceId}`,
        ...metaData?.("SearchEntityClicked"),
      }),
    });
  };

  const sendPromptCardFavoriteEvent = (
    { prompt }: LoggerProps,
    favorite: boolean
  ) => {
    logger.log3sEvent?.({
      localTime: getIsoTimeStringWithMs(new Date()),
      eventType: "EntityActionTaken",
      logicalId,
      id: prompt.ReferenceId ?? "null",
      scenario: scenarioName,
      metaData: JSON.stringify({
        referenceId: `${prompt.ReferenceId}`,
        EntityActionTakenType: favorite ? "Download" : "Unsubscribe",
        ...metaData?.("EntityActionTaken"),
      }),
    });
  };

  const sendPromptCopyEvent = ({ prompt }: LoggerProps) => {
    logger.log3sEvent?.({
      localTime: getIsoTimeStringWithMs(new Date()),
      eventType: "EntityActionTaken",
      logicalId,
      id: prompt.ReferenceId ?? "null",
      scenario: scenarioName,
      metaData: JSON.stringify({
        referenceId: `${prompt.ReferenceId}`,
        EntityActionTakenType: "SendCopy",
        ...metaData?.("EntityActionTaken"),
      }),
    });
  };

  const sendPromptCopyLinkEvent = ({ prompt }: LoggerProps) => {
    logger.log3sEvent?.({
      localTime: getIsoTimeStringWithMs(new Date()),
      eventType: "EntityActionTaken",
      logicalId,
      id: prompt.ReferenceId ?? "null",
      scenario: scenarioName,
      metaData: JSON.stringify({
        referenceId: `${prompt.ReferenceId}`,
        EntityActionTakenType: "CopyLink",
        ...metaData?.("EntityActionTaken"),
      }),
    });
  };

  const sendPromptShareViaEmailEvent = ({ prompt }: LoggerProps) => {
    logger.log3sEvent?.({
      localTime: getIsoTimeStringWithMs(new Date()),
      eventType: "EntityActionTaken",
      logicalId,
      id: prompt.ReferenceId ?? "null",
      scenario: scenarioName,
      metaData: JSON.stringify({
        referenceId: `${prompt.ReferenceId}`,
        EntityActionTakenType: "Share",
        ...metaData?.("EntityActionTaken"),
      }),
    });
  };

  return {
    sendPromptCardClickEvent,
    sendPromptCardFavoriteEvent,
    sendPromptCopyEvent,
    sendPromptCopyLinkEvent,
    sendPromptShareViaEmailEvent,
  };
};
